/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
// import addIcon from "../images/add.svg";

(function () {
  const viewportHeight = Number(window.innerHeight);

  const header = document.getElementById("site-header");
  const navbar = document.querySelector("#site-header .navbar");

  const siteNavigation = document.getElementById("menu-container");

  // Return early if the navigation doesn't exist.
  if (!siteNavigation) {
    return;
  }

  const button = document.getElementById("site-header-menu-toggle");
  let headerNav = document.getElementById("site-header");

  // Return early if the button doesn't exist.
  if (!button) {
    return;
  }

  const menu = siteNavigation.getElementsByTagName("ul")[0];

  // Hide menu toggle button if menu is empty and return early.
  if ("undefined" === typeof menu) {
    button.style.display = "none";
    return;
  }

  if (!menu.classList.contains("nav-menu")) {
    menu.classList.add("nav-menu");
  }
  // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
  button.addEventListener("click", function (e) {
    e.preventDefault();

    button.classList.toggle("open");
    if (!siteNavigation.classList.contains("open-menu")) {
      siteNavigation.classList.add("open-menu");
      headerNav.classList.add("header-top-open");
      siteNavigation.style.height = "auto";
      // let height = siteNavigation.clientHeight + "px";
      // siteNavigation.style.height = "0px";
      // setTimeout(function () {
      //   siteNavigation.style.height = height;
      // }, 0);

      setTimeout(function () {
        let navbarHeight = Number(navbar.clientHeight);

        if (navbarHeight >= viewportHeight) {
          header.classList.add("overflow");
          document.body.classList.add("overflow-hidden");
        }
      }, 500);
    } else {
      header.classList.remove("overflow");
      document.body.classList.remove("overflow-hidden");

      siteNavigation.style.height = "0px";

      siteNavigation.classList.remove("open-menu");
      headerNav.classList.remove("header-top-open");
    }
  });

  // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
  document.addEventListener("click", function (event) {
    const isClickInside = siteNavigation.contains(event.target);

    if (!isClickInside) {
      siteNavigation.classList.remove("toggled");
      button.setAttribute("aria-expanded", "false");
    }
  });

  // Get all the link elements within the menu.
  const links = menu.getElementsByTagName("a");

  // Get all the link elements with children within the menu.
  const linksWithChildren = menu.querySelectorAll(
    ".menu-item-has-children > a, .page_item_has_children > a"
  );

  // Toggle focus each time a menu link is focused or blurred.
  for (const link of links) {
    link.addEventListener("focus", toggleFocus, true);
    link.addEventListener("blur", toggleFocus, true);
  }

  /**
   * Sets or removes .focus class on an element.
   */
  function toggleFocus() {
    if (event.type === "focus" || event.type === "blur") {
      let self = this;
      // Move up through the ancestors of the current link until we hit .nav-menu.
      while (!self.classList.contains("nav-menu")) {
        // On li elements toggle the class .focus.
        if ("li" === self.tagName.toLowerCase()) {
          self.classList.toggle("focus");
        }
        self = self.parentNode;
      }
    }

    if (event.type === "touchstart") {
      const menuItem = this.parentNode;
      event.preventDefault();
      for (const link of menuItem.parentNode.children) {
        if (menuItem !== link) {
          link.classList.remove("focus");
        }
      }
      menuItem.classList.toggle("focus");
    }
  }
  function submenuToggle(item) {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      const parentLi = e.target.closest(".menu-item-has-children");
      if (!parentLi) return;

      const currentDropDown = parentLi.querySelector("ul, .lucio-megamenu");
      if (!currentDropDown) return;

      e.target.classList.toggle("open");

      const isMegaMenu = currentDropDown.classList.contains("corsica-megamenu");

      // ✅ scope to parentLi
      const targetDropDown = isMegaMenu
        ? parentLi.querySelector(".main-ul-wrap.menu-depth-1")
        : currentDropDown;

      if (!targetDropDown) return;

      const isOpen = targetDropDown.classList.contains("open-menu");

      if (!isOpen) {
        // ✅ Close siblings first
        const siblingLis = parentLi.parentElement.querySelectorAll(
          ".menu-item-has-children"
        );
        siblingLis.forEach((sibling) => {
          if (sibling !== parentLi) {
            const openMenu = sibling.querySelector(".open-menu");
            const openIcon = sibling.querySelector(".icon-wrapper.open");

            if (openMenu) {
              openMenu.classList.remove("open-menu");
              openMenu.style.height = "0px";
            }
            if (openIcon) {
              openIcon.classList.remove("open");
            }
          }
        });

        // OPEN current
        targetDropDown.classList.add("open-menu");
        targetDropDown.style.height = "auto";

        const height = targetDropDown.scrollHeight + "px";
        const menuHeight =
          Number(siteNavigation.clientHeight) + targetDropDown.clientHeight;

        targetDropDown.style.height = "0px";
        siteNavigation.style.height = menuHeight + "px";

        setTimeout(() => {
          targetDropDown.style.height = height;
        }, 0);
      } else {
        // CLOSE
        const menuHeight =
          Number(siteNavigation.clientHeight) - targetDropDown.clientHeight;

        siteNavigation.style.height = menuHeight - 1 + "px";
        targetDropDown.classList.remove("open-menu");
        targetDropDown.style.height = "0px";
      }

      setTimeout(() => {
        const navbarHeight = Number(navbar.clientHeight);
        if (navbarHeight >= viewportHeight) {
          header.classList.add("overflow");
          document.body.classList.add("overflow-hidden");
        } else {
          // header.classList.remove("overflow");
          document.body.classList.remove("overflow-hidden");
        }
      }, 500);
    });
  }
  function subOfSubToggle(item) {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      const parentLi = e.target.closest(".menu-item-has-children");
      const currentDropDown = parentLi.querySelector(".menu-depth-2");
      if (!currentDropDown) return;

      const depth1Wrapper = parentLi.closest(".menu-depth-1");
      const menuContainer = document.getElementById("menu-container");

      const isOpen = currentDropDown.classList.contains("open-menu");

      // close siblings
      const siblingLis = parentLi.parentElement.querySelectorAll(
        ".menu-item-has-children"
      );
      siblingLis.forEach((sibling) => {
        if (sibling !== parentLi) {
          const openMenu = sibling.querySelector(".menu-depth-2.open-menu");
          const openIcon = sibling.querySelector(".icon-wrapper.open");

          if (openMenu) {
            openMenu.style.height = openMenu.scrollHeight + "px";
            requestAnimationFrame(() => {
              openMenu.style.height = "0px";
            });
            openMenu.addEventListener(
              "transitionend",
              () => {
                openMenu.classList.remove("open-menu");
                openMenu.style.height = "";
              },
              { once: true }
            );
          }
          if (openIcon) openIcon.classList.remove("open");
          sibling.classList.remove("active-open-parent");
        }
      });

      e.target.classList.toggle("open");

      if (!isOpen) {
        // OPEN
        currentDropDown.classList.add("open-menu");
        currentDropDown.style.height = "0px";
        currentDropDown.offsetHeight; // reflow
        const targetHeight = currentDropDown.scrollHeight;

        // expand submenu + parents at once
        currentDropDown.style.height = targetHeight + "px";
        if (depth1Wrapper) depth1Wrapper.style.height = "auto";
        if (menuContainer) menuContainer.style.height = "auto";

        currentDropDown.addEventListener(
          "transitionend",
          () => {
            currentDropDown.style.height = "auto";
          },
          { once: true }
        );
      } else {
        currentDropDown.style.height = currentDropDown.scrollHeight + "px";
        requestAnimationFrame(() => {
          currentDropDown.style.height = "0px";
        });

        currentDropDown.addEventListener(
          "transitionend",
          () => {
            currentDropDown.classList.remove("open-menu");
            currentDropDown.style.height = "";
            if (depth1Wrapper) depth1Wrapper.style.height = "auto";
            if (menuContainer) menuContainer.style.height = "auto";
          },
          { once: true }
        );
      }
    });
  }

  let hasChildren = Array.from(
    document.querySelectorAll(".menu-item-has-children")
  );

  hasChildren.forEach((item) => {
    const anchor = item.querySelector("a");
    const iconWrapper = document.createElement("SPAN");
    iconWrapper.classList.add("icon-wrapper", "d-xl-none");

    if (anchor && anchor.parentElement === item) {
      anchor.insertAdjacentElement("afterend", iconWrapper);
    } else {
      item.appendChild(iconWrapper);
    }
  });

  const submenuIcon = Array.from(
    document.querySelectorAll(
      ".primary-menu > ul > .menu-item-has-children > .icon-wrapper"
    )
  );
  submenuIcon.map((item) => {
    submenuToggle(item);
  });

  const subOfSubIcon = Array.from(
    document.querySelectorAll(
      ".menu-item-has-children .menu-item-has-children  .icon-wrapper"
    )
  );
  subOfSubIcon.map((item) => {
    subOfSubToggle(item);
  });
})();

// On scroll event add class
let scrollpos = window.scrollY;

let header = document.getElementById("site-header");
let scrollChange = 30;
let mainDiv = document.getElementById("page");
window.addEventListener("scroll", function () {
  scrollpos = window.scrollY;

  if (
    scrollpos >= scrollChange &&
    mainDiv.classList.contains("page-with-fixed-header")
  ) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }

  // Custom for
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 1200) {
      const header = document.getElementById("site-header");
      const menuContainer = document.getElementById("menu-container");
      const toggleBtn = document.getElementById("site-header-menu-toggle");
      if (toggleBtn) {
        toggleBtn.classList.remove("open");
      }
      // Remove open state classes/styles
      header.classList.remove("header-top-open");
      document.body.classList.remove("overflow-hidden");

      if (menuContainer) {
        menuContainer.classList.remove("open-menu");
        menuContainer.style.height = "";
      }

      // Also close all open dropdowns
      const openMenus = document.querySelectorAll(".open-menu");
      openMenus.forEach((menu) => {
        menu.classList.remove("open-menu");
        menu.style.height = "";
      });

      const openIcons = document.querySelectorAll(".icon-wrapper.open");
      openIcons.forEach((icon) => {
        icon.classList.remove("open");
      });
    }
  });
});
const activeMenuItem = document.querySelectorAll(".icon-wrapper");

activeMenuItem.forEach((item) => {
  item.addEventListener("click", function () {
    const parentLi = item.closest("li");

    if (item.classList.contains("open")) {
      if (parentLi) {
        const siblings = parentLi.parentElement.querySelectorAll("li");
        siblings.forEach((sibling) => {
          if (sibling !== parentLi) {
            sibling.classList.remove("active-open-parent");
          }
        });

        parentLi.classList.add("active-open-parent");
      }
    } else {
      if (parentLi) {
        parentLi.classList.remove("active-open-parent");
      }
    }
  });
});
